import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { animate, style, transition, trigger } from '@angular/animations';
import { AutoResizeDirective } from '@shared/directives';
import { InputTextComponent } from '@shared/components/tools/forms/input-text/input-text.component';
import { FormItem } from '@shared/components/tools/forms/form-section/form-section-interface';
import { FIELD_TYPE_TEXT } from '@core/services/inner-use/const/staticDefinitions';

export interface ContactFormValue {
  objet: string;
  message: string;
}

@Component({
  selector: 'app-contact-form-modal',
  standalone: true,
  imports: [ReactiveFormsModule, AutoResizeDirective, InputTextComponent],
  templateUrl: './contact-form-modal.component.html',
  styleUrl: './contact-form-modal.component.scss',
  animations: [
    trigger('fadeScale', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(12px) scale(0.96)' }),
        animate('220ms cubic-bezier(0.16, 1, 0.3, 1)', style({ opacity: 1, transform: 'translateY(0) scale(1)' }))
      ]),
      transition(':leave', [
        animate('160ms ease-in', style({ opacity: 0, transform: 'translateY(4px) scale(0.98)' }))
      ])
    ])
  ]
})
export class ContactFormModalComponent implements OnInit {
  @Output() submitted = new EventEmitter<ContactFormValue>();
  @Output() cancelled = new EventEmitter<void>();

  form!: FormGroup;

  readonly messageFieldData: FormItem = {
    type: FIELD_TYPE_TEXT,
    controlName: 'message',
    label: 'Message',
    placeholder: 'Votre message...',
    value: '',
    pattern: '',
    isTextarea: true,
    isRequired: true,
  };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      objet: ['', Validators.required],
      message: ['', Validators.required],
    });
  }

  submitHandler(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.submitted.emit(this.form.value as ContactFormValue);
  }

  cancelHandler(): void {
    this.cancelled.emit();
  }

  onBackdropClick(event: Event): void {
    if ((event as MouseEvent).target === (event as MouseEvent).currentTarget) {
      this.cancelHandler();
    }
  }
}
